import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SLSItemExValoresClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/custom-field-values');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os items');
    }
  }

  async index(queries = {}) {
    try {
      const { data } = await this.api.get('/custom-field-values', { params: queries });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os Valores do campo');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/custom-field-values', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar Valores do campo');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/custom-field-values/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar Valores do campo');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/custom-field-values/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar Valores do campo');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/custom-field-values/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar Valores do campo');
    }
  }

  async findAllByItem(id_item) {
    try {
      const { data } = await this.api.get(`/custom-field-values/item/${id_item}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar os Valores do campo');
    }
  }
}
